export default __webpack_public_path__ + "static/media/image9.e9506767.png";